import {
    getLocations,
    saveLocations,
    deleteLocations,
} from './../api/webApplicationApi';

export class Location {
    private _location: omLocation;
    private _lastError: Error;

    public constructor(siteID: string) {
        this._location = {
            siteID: siteID,
            latitude: undefined,
            longitude: undefined,
            locationType: 'postal_code',
            location: undefined,
            naturalGasRate: 0,
            electricityRate: 0,
            oilRate: 0,
            powerCycles: 60,
        };
    }

    public static createFromObject(location: omLocation): Location {
        const obj = new Location(location.siteID);
        obj._location = location;
        return obj;
    }

    public async load(): Promise<boolean> {
        const response = await getLocations([this._location.siteID]);
        if (response.length > 0) {
            this._location = response[0];
            return true;
        }
        return false;
    }

    public async save(): Promise<boolean> {
        if (this._location.latitude == undefined) {
            this._lastError = new Error('Latitude is undefined');
            return false;
        }

        if (this._location.longitude == undefined) {
            this._lastError = new Error('longitude is undefined');
            return false;
        }

        if (this._location.locationType == undefined) {
            this._lastError = new Error('Location Type is undefined');
            return false;
        }

        if (this._location.location == undefined) {
            this._lastError = new Error('Location is undefined');
            return false;
        }

        if (this._location.naturalGasRate == undefined) {
            this._lastError = new Error('Natural Gas Rate is undefined');
            return false;
        }

        if (this._location.electricityRate == undefined) {
            this._lastError = new Error('Electricity Rate is undefined');
            return false;
        }

        if (this._location.oilRate == undefined) {
            this._lastError = new Error('Oil Rate is undefined');
            return false;
        }

        if (this._location.powerCycles == undefined) {
            this._lastError = new Error('Power Cycles Rate is undefined');
            return false;
        }

        this._lastError = undefined;
        try {
            const response = await saveLocations([this._location]);
            return response;
        } catch (error: any) {
            this._lastError = error;
            return false;
        }
    }

    public async delete(): Promise<boolean> {
        this._lastError = undefined;
        try {
            const response = await deleteLocations([this._location.siteID]);
            return response;
        } catch (error: any) {
            this._lastError = error;
            return false;
        }
    }

    public get lastError(): Error {
        return this._lastError;
    }

    public get longitude(): number {
        return this._location.longitude;
    }

    public set longitude(longitude: number) {
        this._location.longitude = longitude;
    }

    public get latitude(): number {
        return this._location.latitude;
    }

    public set latitude(latitude: number) {
        this._location.latitude = latitude;
    }

    public get postalCode(): string {
        return this._location.location;
    }

    public set postalCode(postalCode: string) {
        this._location.location = postalCode;
    }

    public get powerCycles(): number {
        return this._location.powerCycles;
    }

    public set powerCycles(powerCycles: number) {
        this._location.powerCycles = powerCycles;
    }

    public get electricityRate(): number {
        return this._location.electricityRate;
    }

    public set electricityRate(electricityRate: number) {
        this._location.electricityRate = electricityRate;
    }

    public get naturalGasRate(): number {
        return this._location.naturalGasRate;
    }

    public set naturalGasRate(naturalGasRate: number) {
        this._location.naturalGasRate = naturalGasRate;
    }

    public get oilRate(): number {
        return this._location.oilRate;
    }

    public set oilRate(oilRate: number) {
        this._location.oilRate = oilRate;
    }
}
